import { useHistory, Link } from 'react-router-dom';

import Icon from 'Components/Icon';

import './style.scss';

const BackArrow = (props) => {
	const { to } = props;
	const history = useHistory();

	return (
		<Link className="back-arrow" to={to || history.goBack()}>
			<Icon isHM name="utilitary_backandroid" />
		</Link>
	);
};

BackArrow.propTypes = {
	to: PropTypes.string
};
BackArrow.defaultProps = {
	to: null
};

export default BackArrow;
